// cleanup_convert_to_typescript_file_CREATE_RECURRING_TRANSFERS

import React from 'react';
import PropTypes from 'prop-types';

import Modal, { TYPES } from '@glu/modal-react';

import useLocale from 'components/useLocale/useLocale';
import { PAYMENT_ACTIONS, DEFAULT_PROPS } from 'constants.js';

import useStyles from './recurringTransferModal.styles';

const { EMPTY_FUNCTION } = DEFAULT_PROPS;

export const RecurringTransferCancelModal = ({
  action = '',
  onClose = EMPTY_FUNCTION,
  opened = false
}) => {
  const { modalDialog } = useStyles();
  const locale = useLocale();

  const modalTitle =
    action === PAYMENT_ACTIONS.MODIFY_TEMPLATE
      ? locale['common.unsavedChanges']
      : locale['create.payment.back'];

  return (
    <Modal
      btnPrimaryAttributes={{
        'data-qa': 'leave',
        className: 'btn btn-primary',
        autoFocus: true
      }}
      btnPrimaryText={locale['common.leave']}
      btnTertiaryAttributes={{ 'data-qa': 'cancel', className: 'btn btn-tertiary' }}
      btnTertiaryText={locale['common.cancel']}
      classes={{
        card: modalDialog
      }}
      dataQa="recurring-transfer-cancel"
      header={modalTitle}
      onBtnPrimaryClick={action}
      onBtnTertiaryClick={onClose}
      onClose={onClose}
      open={opened}
      type={TYPES.ERROR}
    >
      <p>
        {locale['create.payment.back.confirm']}
        <br />
        {locale['create.payment.back.confirm.line2']}
      </p>
    </Modal>
  );
};

RecurringTransferCancelModal.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  action: PropTypes.string
};

export default RecurringTransferCancelModal;
